// import React from 'react';
// import ImgAnimet from '../../images/work-image.jpg'

// const WorkSection = (props) => {
//     return (
//         <section className={"" + props.hclass}>
//             <div className="title">
//                 <h2 className="fade_bottom">Lets See How <br />
//                     We Work</h2>
//                 <p className="fade_bottom">Designing innovative residential spaces, state-of-the-art
//                     commercial hubs, or inspiring public structures, Blaze thrives on creating iconic designs that blend
//                     art, science, and purpose seamlessly.</p>
//             </div>
//             <div className="row">
//                 <div className="col-lg-6 col-12 fade_bottom">
//                     <div className="item">
//                         <h3>Planning</h3>
//                         <div className="text">
//                             <span>Step 1</span>
//                             <p>This involves determining the anticipated costs associated with the project</p>
//                         </div>
//                     </div>
//                     <div className="item">
//                         <h3>Estimating</h3>
//                         <div className="text">
//                             <span>Step 2</span>
//                             <p>This involves determining the anticipated costs associated with the project</p>
//                         </div>
//                     </div>
//                     <div className="item">
//                         <h3>Building</h3>
//                         <div className="text">
//                             <span>Step 3</span>
//                             <p>This involves determining the anticipated costs associated with the project</p>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-lg-6 col-12">
//                     <div className="image">
//                         <img className="img-animet fade_bottom"  src={ImgAnimet} alt="" />
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default WorkSection;
import React from "react";

const WorkSection = (props) => {
  return (
    <section className={props.hclass}>
      <div className="title">
        <h2
          className="fade_bottom"
          style={{
            fontWeight: 900,
            fontSize: "clamp(28px, 10vw, 56px)",
            lineHeight: "1.1",
            textTransform: "none",
            wordBreak: "break-word",
            textAlign: "left",
          }}
        >
          See How <br />
          We Build Your Home
        </h2>

        <p className="fade_bottom" style={{ textAlign:"left", marginTop:"10px"}}>
          At Quality Homes And Builders, we follow a simple, transparent, and reliable
          process to deliver high-quality homes. From initial planning to final
          handover, we ensure clear communication, cost clarity, and skilled
          workmanship at every stage.
        </p>
      </div>

      <div className="row">
        {/* Left Content */}
        <div className="col-lg-6 col-12 fade_bottom">
          <div className="item">
            <h3 id="title" className="work-step-heading">Planning & Design</h3>
            <div className="text">
              <p>
                We begin by understanding your ideas, requirements, and budget.
                Our team creates a practical plan and design tailored to your
                lifestyle and long-term needs.
              </p>
            </div>
          </div>

          <div className="item">
            <h3 id="title" className="work-step-heading">Transparent Costing</h3>
            <div className="text">
              <p>
                You receive a detailed and upfront cost breakdown covering
                materials, timelines, and inclusions, ensuring complete
                transparency with no hidden costs.
              </p>
            </div>
          </div>

          <div className="item">
            <h3 id="title" className="work-step-heading">Construction & Handover</h3>
            <div className="text">
              <p>
                Using quality materials and skilled trades, we construct your home
                with precision and care, delivering the finished project on time
                and to the highest standards.
              </p>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="col-lg-6 col-12">
          <div className="image">
            <img
              className="img-animet fade_bottom"
              src="https://res.cloudinary.com/dexvxngzg/image/upload/v1765261792/work-image.39a8d5ed3a85ce0b5c46_ri3hh2.jpg"
              alt="Quality Homes And Builders Construction Process"
            />
          </div>
        </div>
      </div>

      {/* MOBILE OVERRIDES */}
      <style>
        {`
          @media (max-width: 768px) {
            #title h3 {
              font-size: 20px;
              text-align: left;
            }

            .work-step-heading {
              font-size: 18px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default WorkSection;
